<template>
  <div class="flex" >
    <Icon class="flex items-center mr-2 mt-3" name="info" color="grey" />
    <div class="text-xs mt-3 text-gray-700">
      <p class="font-bold" v-text="myTitle"></p>
      <p>
        {{ myDescription }}
      </p>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon.vue";

export default {
  props: ["myTitle", "myDescription"],
  components: { Icon },

}
</script>

<style>

</style>